<script>
  import Banner from '../utility/banner.svelte'
  import Contact from '../parts/contact.svelte'
  import Footer from '../parts/footer.svelte'
  import Teams from '../pages/Teams.svelte'
  export let title
  document.documentElement.scrollTop = 0
</script>

<svelte:head>
  <title>
    {title} - Devanga Sowdeshwari Amman Association of North America (DSAANA)
  </title>
</svelte:head>

<Banner title="{title}" />

<section class="AboutUs">
  <img
    width="100%"
    src="assets/images/services/About Us Page Image(remove Pongal).jpg"
    alt="" />
  <div>
    <p>
      Devanga Sowdeshwari Amman Association of North America (DSAANA) is a
      non-profit organization with a mission to build a vibrant Kannada Devanga
      Community and promote rich culture in the North America. The main purpose
      is to meet the community’s growing need for a religious, spiritual &
      cultural center and also to serve the needy in the fields of medical
      relief, education, disaster relief services, community services,
      empowerment of women, youth and children, etc.
    </p>
  </div>

  <div>
    <ul class="list-group">
      <li class="list-group-item"><h2>Primary Goals:</h2></li>
      <li class="list-group-item">Community Service</li>
      <li class="list-group-item">
        Ensure Healthy Lives and promote Well Being for all at all ages
      </li>
      <li class="list-group-item">Economic Growth</li>
      <li class="list-group-item">
        Ensure Inclusive and quality education and promote lifelong learning
      </li>
      <li class="list-group-item">End hunger, Provide Education.</li>
    </ul>
  </div>

  <div>
    <h2>Vision:</h2>
    <p>
      DSAANA will continue to serve as a true beacon of Indian culture in the
      present times and strive to teach the modern generation of Indians, and
      provide a platform for all members to come together socially, culturally
      and religiously in harmony. <br /><br />

      To help Create Society free from Discrimination where people with
      disability and under privileged become earning members and contribute to
      the Society and fall in the main stream of Society. Eradicate Rural
      poverty and ensure sustainable Society with Empowerment.
    </p>
  </div>

  <div>
    <ul class="list-group">
      <li class="list-group-item"><h2>Our Core Values:</h2></li>
      <li class="list-group-item">
        A Sanctuary for all families in the community comes together socially
        and culturally.
      </li>
      <li class="list-group-item">Accountability and Transparency.</li>
      <li class="list-group-item">Gender and Diversity</li>
      <li class="list-group-item">Secular policy</li>
      <li class="list-group-item">Respect of human values and rights</li>
      <li class="list-group-item">Democratic functioning</li>
      <li class="list-group-item">Social Justice</li>
      <li class="list-group-item">Child centered policy</li>
    </ul>
  </div>
  <br />
</section>
<Teams />
<!-- <Contact /> -->
<Footer />

<style lang="scss">
  .AboutUs {
    width: 90%;
    margin: auto;

    div {
      margin-top: 50px;
    }
  }
</style>
